import React, { useState } from 'react';
import { Checkbox, FormControl, FormControlLabel, TextField } from '@mui/material';

import { PropertySelectField } from '@paragon/client-tools';
import { LoadCase } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';

import { finishInsertingLoadCase } from '../../../../store/actions/insertActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { getLoadCasesForActiveComponentDesignSorted } from '../../../../store/selectors/getLoadCasesForActiveComponentDesignSortedSelector';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import InsertionPanelContainer from './InsertionPanelContainer';

export function LoadCaseInsertionSubPanel() {
  const dispatch = useAppDispatch();

  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);
  const loadCases = useAppSelector(getLoadCasesForActiveComponentDesignSorted);
  const component = useAppSelector(getActiveComponentDesign);

  const [name, setName] = useState('');
  const [loadCaseToCopy, setLoadCaseToCopy] = useState<LoadCase | null>(null);
  const [copyManualLoads, setCopyManualLoads] = useState(true);

  if (insertingObjectInfo?.type !== 'loadCase' || !component) return null;

  const isValidLoadCaseName = (name: string) => {
    if (!name || name === '') return false;
    if (loadCases.map((loadCase) => loadCase.name).includes(name)) return false;
    return true;
  };

  return (
    <InsertionPanelContainer
      onInsert={() => {
        if (!loadCaseToCopy) return;
        dispatch(finishInsertingLoadCase(name, loadCaseToCopy.guid, copyManualLoads));
      }}
      disabled={!isValidLoadCaseName(name)}
    >
      <PropertiesPanel title="Load Case Insertion">
        <FormControl margin="normal">
          <PropertySelectField<LoadCase>
            property="Load Case To Copy"
            value={loadCaseToCopy}
            options={loadCases}
            getName={(loadCase) => loadCase.name}
            getValue={(loadCase) => loadCase.guid}
            submit={setLoadCaseToCopy}
            fullWidth
          />
        </FormControl>
        <FormControl margin="normal">
          <TextField
            variant="standard"
            label="New Load Case Name (must be unique)"
            sx={{ width: '100%' }}
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </FormControl>
        <FormControlLabel
          control={
            <Checkbox
              checked={copyManualLoads}
              onChange={(event) => {
                setCopyManualLoads(event.target.checked);
              }}
            />
          }
          label="Copy Manual Loads"
          sx={{ marginTop: '10px' }}
        />
      </PropertiesPanel>
    </InsertionPanelContainer>
  );
}
